import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';

export const authenticationCommonPostRequest = async (apiEndPoint, payload) => {
    const endPoint = commonEndPoint + apiEndPoint;
    // console.log('tokennn', token, apiEndPoint);
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json'
    };

    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const POST_API_ENDPOINTS_AUTH = {
    login: 'moneytransfer/login',
    twoFAuth: 'moneytransfer/VerifyOTP2Fauth',
    resend2FOTP: 'moneytransfer/ResendOTP2Fauth',
    domainImage: 'domain/image',
    resetPasswordStep1: 'verifyResetPasswordstep1',
    resetPasswordVerifyOTP: 'verifyOtpResetPassword',
    resetNewPassword: 'ResetConfirmPassword',
    mpinStatusChecker: 'moneytransfer/merchant/StatusMpin',
    supportAuth: 'moneytransfer/support-auth',
    authLogin: 'authLogin',
    loginWithPhone: 'moneytransfer/loginWithPhone',
    loginWithPhoneVerifyOtp: 'moneytransfer/loginWithPhoneVerifyOtp ',
    checkPhone: 'Selfregister/CheckPhoneNumber',
    registerResendOTP: 'Selfregister/ResendOTP',
    registerVerifyOTP: 'Selfregister/VerifyOTP',
    EmailVerification: 'Selfregister/EmailVerification',
    GetAuthorization: 'Selfregister/GetAuthorization',
    verifyPancard: 'Selfregister/verifyPancard',
    verifyBank: 'Selfregister/verifyBank',
    UpdateKycInfo: 'Selfregister/UpdateKycInfo',
    getStates: 'Selfregister/states',
    getDistricts: 'Selfregister/district',
    getCities: 'Selfregister/city'
};

export const loginRequest = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.login, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const loginWithPhoneRequest = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.loginWithPhone, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const loginWithPhoneVerifyOtpRequest = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.loginWithPhoneVerifyOtp, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const authLoginRequest = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.authLogin, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const resend2FOTP = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.resend2FOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const verify2FAuth = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.twoFAuth, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getDomainImage = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.domainImage, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const resetPasswordStep1 = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.resetPasswordStep1, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const resetPasswordVerifyOTP = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.resetPasswordVerifyOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const resetNewPassword = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.resetNewPassword, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const mpinStatusChecker = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.mpinStatusChecker, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const supportAuthApi = async (payload) => {
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.supportAuth, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpPhoneCheck = async (payload) => {
    //API for self sign up phone verification
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.checkPhone, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpResendOTP = async (payload) => {
    //API for self sign up resend otp
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.registerResendOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpVerifyOTP = async (payload) => {
    //API for self sign up verify otp
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.registerVerifyOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpEmailVerification = async (payload) => {
    //API for self sign up verify email
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.EmailVerification, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpGetAuthorization = async (payload) => {
    //API for self sign up auth verification
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.GetAuthorization, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpVerifyPancard = async (payload) => {
    //API for self sign up pancard verification
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.verifyPancard, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpVerifyBank = async (payload) => {
    //API for self sign up bank verification
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.verifyBank, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const selfSignUpUpdateKycInfo = async (payload) => {
    //API for self sign up update kyc info
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.UpdateKycInfo, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getStatesList = async (payload) => {
    //API for self sign up fetch states
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.getStates, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getDistrictList = async (payload) => {
    //API for self sign up fetch districts
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.getDistricts, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getCitiesList = async (payload) => {
    //API for self sign up fetch cities list
    const response = await authenticationCommonPostRequest(POST_API_ENDPOINTS_AUTH.getCities, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
